import type { IconWeight } from '@phosphor-icons/react/dist/lib/types';
import type { ComponentPropsWithoutRef } from 'react';

import type { IconName } from './types';

import { cn } from '@polyseme/utils/cn/cn-utils';
import { ObjectUtils } from '@polyseme/utils/typescript/typescript-utils';
import { forwardRef } from 'react';

import { ICONS } from './types';

const iconSizes = {
  xs: 12,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
} as const;
export type IconSize = keyof typeof iconSizes;
export const iconSizeList = ObjectUtils.keys(iconSizes);

type IconProps = ComponentPropsWithoutRef<'span'> & {
  name: IconName;
  size?: IconSize;
  weight?: IconWeight;
};

export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, name, size = 'sm', weight, ...props }, ref) => {
    const IconComponent = ICONS[name] ?? ICONS['bug'];

    return (
      <IconComponent
        ref={ref}
        className={cn('shrink-0', className)}
        size={iconSizes[size]}
        weight={weight}
        {...props}
        aria-hidden={true}
        focusable={false}
      />
    );
  }
);

Icon.displayName = 'Icon';
